import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppURL } from 'src/app/app.url';
import { AlertService } from 'src/app/services/alert.service';
import { AppService } from 'src/app/services/app.service';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-check',
  templateUrl: './check.component.html',
  styleUrls: ['./check.component.scss']
})
export class CheckComponent {
  ogId: string = ""
  realmid: string = ""
  constructor(private ac: ActivatedRoute,
    private router: Router,
    private ds: DataService,
    private http: HttpClient,
    private app: AppService,
    private alert: AlertService
  ) {
    this.ogId = this.ac.snapshot.queryParams['og']
    this.realmid = this.ac.snapshot.queryParams['realmid']
    if (this.ogId && this.realmid) {
      this.ds.ogId = this.ogId
      this.ds.realmid = this.realmid
      sessionStorage.setItem('ogid', this.ogId)
      sessionStorage.setItem('realmid', this.realmid)

      let model = {
        Ogid: this.ds.ogId,
        Systemid: environment.keySystem
      }
      this.http.post(`${environment.apiPackage}/system/role`, model).subscribe({
        next: (res: any) => {
          if (this.ds.ogId) this.getLicense();
        },
        error: (err: any) => {
          this.alert.dialog('', err.error.message, 'warning')
          setTimeout(() => {
            window.location.replace(`${environment.replaceUrl}/check/${environment.keySystem}?system=${window.location.origin + environment.pathURL}`)
          }, 1500);
        }
      })
    }
    else {
      window.location.replace(`${environment.replaceUrl}/check/${environment.keySystem}?system=${window.location.origin + environment.pathURL}`)
    }
  }

  getLicense() {
    this.http.get(`${environment.apiPackage}/getLicense/og/${this.ds.ogId}/${environment.keySystem}`).subscribe({
      next: (res: any) => {
        this.ds.license = res.data.LicenseKey
        sessionStorage.setItem('license', this.ds.license)
        if (this.ds.license) {
          this.router.navigate(['/', AppURL.member], { queryParams: { license: this.ds.license } })
        }
        else {
          this.app.viewPage = false
          this.app.License = false
        }
      }
    })
  }
}
